import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../index.css";


function AdminPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND}/api/admin/Adminlogin`, { email, password });

      if (response.data.success) {
        localStorage.setItem("isAuthenticated", "true");
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("userId", response.data.userId);
        navigate("/dashboard");
      } else {
        setError(response.data.message || "Login failed. Please try again.");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Server error. Please try again later.");
    }
  };

  return (
    <div className="adminpage-container d-flex flex-column justify-content-center align-items-center vh-100">
      <div className="adminpage-form rounded shadow p-4">
        <h1 className="text-center mb-3 adminpage-heading">Admin Page</h1>
        {error && <div className="alert alert-danger">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="mb-1">
            <label className="form-label"><strong>Email</strong></label>
            <input
              type="email"
              name="email"
              value={email}
              placeholder="Enter your email"
              autoComplete="off"
              className="form-control"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label"><strong>Password</strong></label>
            <div className="input-group">
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                value={password}
                placeholder="Enter your password"
                autoComplete="off"
                className="form-control"
                onChange={(e) => setPassword(e.target.value)}
              />
              <span
                className="input-group-text bg-white"
                onClick={() => setShowPassword(!showPassword)}
                style={{ cursor: "pointer" }}
              >
                <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
              </span>
            </div>
          </div>
          <button type="submit" className="btn btn-dark w-100">
            Login
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminPage;
